<template>
  <b-collapse class="evaluation-card" animation="slide" :open="isOpen" data-cy="gops-data">
    <template #trigger="{ open }">
      <header class="card-header" role="banner" :aria-expanded="open.toString()">
        <p class="card-header-title">
          Información financiera
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </header>
    </template>
    <section class="card-block p-0 pt-1 pb-1">
      <div class="subcard is-gray">
        <b-field label="Renta promedio" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">CLP</a>
            </p>
            <b-input
              :value="formatNumberByCountry(simulation.offerInputs.disposableIncome)"
              :disabled="readOnly"
              class="pr-2"
              size="is-small"
              :type="readOnly ? 'string' : 'number'"
              placeholder="Ingresa valor en UF"
              expanded />
            <b-button
              class="header-icon"
              size="is-small"
              data-cy="propertiesAverageIncome"
              :icon-left="propertiesAverageIncome ? 'angle-down' : 'angle-right'"
              @click="togglePropertiesAverageIncome" />
          </div>
        </b-field>
        <div v-if="propertiesAverageIncome" class="fields-has-text-right">
          <b-field horizontal class="has-addons">
            <div class="field has-addons">
              <small class="has-text-grey-light subtitle">Deudor</small>
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <small class="has-text-grey-light subtitle">Codeudor</small>-->
            <!--            </div>-->
          </b-field>
          <b-field label="Dependiente" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">CLP</a>
              </p>
              <b-input
                :value="formatNumberByCountry(simulation.offerInputs.disposableIncome)"
                :disabled="readOnly"
                size="is-small"
                :type="readOnly ? 'string' : 'number'"
                placeholder="Ingresa valor en UF"
                expanded />
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <p class="control">-->
            <!--                <a class="button is-static">CLP</a>-->
            <!--              </p>-->
            <!--              <b-input-->
            <!--                v-model="simulation.offerInputs.codebtorIncome"-->
            <!--                :disabled="readOnly"-->
            <!--                size="is-small"-->
            <!--                type="number"-->
            <!--                placeholder="Ingresa valor en UF"-->
            <!--                expanded />-->
            <!--            </div>-->
          </b-field>
          <b-field label="Independiente" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">CLP</a>
              </p>
              <b-input
                :disabled="readOnly"
                value="0"
                size="is-small"
                type="number"
                placeholder="Ingresa valor en UF"
                expanded />
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <p class="control">-->
            <!--                <a class="button is-static">CLP</a>-->
            <!--              </p>-->
            <!--              <b-input-->
            <!--                :disabled="readOnly"-->
            <!--                value="0"-->
            <!--                size="is-small"-->
            <!--                type="number"-->
            <!--                placeholder="Ingresa valor en UF"-->
            <!--                expanded />-->
            <!--            </div>-->
          </b-field>
        </div>
      </div>

      <div class="subcard is-gray">
        <div class="subcard-header">
          <p class="header-title">Deuda mensual</p>
          <b-button
            class="header-icon"
            size="is-small"
            :icon-left="propertiesMonthlyDebt ? 'angle-up' : 'angle-down'"
            @click="togglePropertiesMonthlyDebt" />
        </div>

        <div v-if="propertiesMonthlyDebt" class="subcard-content fields-has-text-right">
          <b-field label=" " horizontal class="has-addons">
            <div class="field has-addons">
              <small class="has-text-grey-light subtitle">Deudor</small>
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <small class="has-text-grey-light subtitle">Codeudor</small>-->
            <!--            </div>-->
          </b-field>
          <b-field label="Corto plazo" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">CLP</a>
              </p>
              <b-input
                :value="formatNumberByCountry(simulation.offerInputs.shortTermMonthlyFee)"
                :disabled="readOnly"
                size="is-small"
                :type="readOnly ? 'string' : 'number'"
                placeholder="Ingresa valor en UF"
                expanded />
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <p class="control">-->
            <!--                <a class="button is-static">CLP</a>-->
            <!--              </p>-->
            <!--              <b-input-->
            <!--                :disabled="readOnly"-->
            <!--                value="0"-->
            <!--                size="is-small"-->
            <!--                type="number"-->
            <!--                placeholder="Ingresa valor en UF"-->
            <!--                expanded />-->
            <!--            </div>-->
          </b-field>

          <b-field label="Largo plazo" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">CLP</a>
              </p>
              <b-input
                :value="formatNumberByCountry(simulation.offerInputs.longTermMonthlyFee)"
                :disabled="readOnly"
                size="is-small"
                :type="readOnly ? 'string' : 'number'"
                placeholder="Ingresa valor en UF"
                expanded />
            </div>
            <!--            <div class="field has-addons">-->
            <!--              <p class="control">-->
            <!--                <a class="button is-static">CLP</a>-->
            <!--              </p>-->
            <!--              <b-input-->
            <!--                :disabled="readOnly"-->
            <!--                value="0"-->
            <!--                size="is-small"-->
            <!--                type="number"-->
            <!--                placeholder="Ingresa valor en UF"-->
            <!--                expanded />-->
            <!--            </div>-->
          </b-field>
        </div>
      </div>

      <div v-if="eligibilityData" class="subcard is-gray">
        <div class="subcard-header">
          <p class="header-title">Elegibilidad</p>
          <b-button
            class="header-icon"
            size="is-small"
            :icon-left="propertiesEligibility ? 'angle-up' : 'angle-down'"
            @click="togglePropertiesEligibility" />
        </div>

        <div v-if="propertiesEligibility" class="subcard-content fields-has-text-right">
          <b-field label="Tipo" horizontal>
            <b-select
              v-model="evaluationEligibility"
              :disabled="readOnly"
              size="is-small"
              placeholder="Selecciona un tipo"
              expanded>
              <option value="Approved">Aprobado</option>
              <option value="Reviewable">Revisión</option>
              <option value="Refused">Rechazado</option>
            </b-select>
          </b-field>

          <b-field horizontal class="has-addons">
            <div class="field has-addons">
              <small class="has-text-grey-light subtitle">Deudor</small>
            </div>
          </b-field>
          <b-field label="Edad" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.age" :eligibility-param="eligibilityParams.age" :print="true" />
          </b-field>

          <b-field label="Nacionalidad" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.nationality" :eligibility-param="eligibilityParams.nationality " />
          </b-field>

          <b-field label="Residencia" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.residence" :eligibility-param="eligibilityParams.residence " />
          </b-field>

          <b-field label="PEP" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.publicExposedPerson" :eligibility-param="eligibilityParams.publicExposedPerson " />
          </b-field>

          <b-field label="Lista negra externa" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.blackListExternal" :eligibility-param="eligibilityParams.blackListExternal " />
          </b-field>

          <b-field label="Lista negra interna" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.blackListInternal" :eligibility-param="eligibilityParams.blackListInternal " />
          </b-field>

          <section class="job-continuity">
            <div class="collapse-inner text-center">
              <p class="card-header-title">
                Continuidad laboral
              </p>
            </div>

            <article class="fields-has-text-right">
              <b-field label="Dependiente" horizontal custom-class="has-text-grey">
                <EligibilityTag :eligibility-data="eligibilityDataProps.jobContinuity" :eligibility-param="eligibilityParams.jobContinuity " :inverse="true" />
              </b-field>

              <b-field label="Independiente" horizontal custom-class="has-text-grey">
                <div class="field is-flex is-justify-content-space-between">--</div>
              </b-field>
            </article>
          </section>

          <b-field label="Antigüedad laboral" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.jobSeniority" :eligibility-param="eligibilityParams.jobSeniority" :inverse="true" />
          </b-field>

          <b-field label="Causas judiciales" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.lawsuit" :eligibility-param="eligibilityParams.lawsuit" />
          </b-field>

          <b-field label="Nivel de mora" horizontal>
            <EligibilityTag :eligibility-data="eligibilityDataProps.defaultRate" :eligibility-param="eligibilityParams.defaultRate " />
          </b-field>
        </div>
      </div>
    </section>
  </b-collapse>
</template>

<script>
import { mapState } from 'vuex';
import EligibilityTag
  from '@/ui/components/internal/evaluations/verify/EligibilityTag.vue';
import { formatNumberByCountry } from '@/infrastructure/format';

export default {
  name: 'FinancialInformationCard',
  components: { EligibilityTag },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      propertiesAverageIncome: true,
      propertiesMonthlyDebt: true,
      propertiesEligibility: true
    };
  },
  computed: {
    ...mapState('evaluation', ['simulation', 'manualEvaluationId', 'eligibilityData', 'eligibilityType', 'eligibilityParams']),
    eligibilityDataProps() {
      function isObject(value) {
        return value && typeof value === 'object';
      }

      function hasProperty(value, prop) {
        return isObject(value) && prop in value;
      }

      function createEligibilityObject(result = null, eligibility = null) {
        return { result, eligibility };
      }

      return ['age', 'nationality', 'residence', 'publicExposedPerson', 'blackListExternal', 'blackListInternal', 'jobContinuity', 'lawsuit', 'jobSeniority', 'defaultRate'].reduce((acc, key) => {
        const value = this.eligibilityData[key];

        if (hasProperty(value, 'result') && hasProperty(value, 'eligibility')) {
          acc[key] = value;
        } else if (hasProperty(value, 'result')) {
          acc[key] = createEligibilityObject(value.result);
        } else if (hasProperty(value, 'eligibility')) {
          acc[key] = createEligibilityObject(null, value.eligibility);
        } else {
          acc[key] = createEligibilityObject();
        }

        return acc;
      }, {});
    },
    evaluationEligibility() {
      return this.eligibilityType;
    }
  },
  methods: {
    formatNumberByCountry(number, usePrefix = true, currencyType = 'primary') {
      if (number === null || number === undefined || number === 0) {
        return '0';
      }
      const newFormat = formatNumberByCountry({ number,
        countryIn: 'cl',
        usePrefix,
        currencyType });
      return newFormat.split('UF')[1];
    },
    togglePropertiesAverageIncome() {
      this.propertiesAverageIncome = !this.propertiesAverageIncome;
    },
    togglePropertiesMonthlyDebt() {
      this.propertiesMonthlyDebt = !this.propertiesMonthlyDebt;
    },
    togglePropertiesEligibility() {
      this.propertiesEligibility = !this.propertiesEligibility;
    }
  }
};
</script>

<style scoped>
.collapse-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 0.75rem;
}

.job-continuity {
  background: #F2F2F2;
  border-radius: 5px;
  padding: 1px 5px;
  margin: 5px -5px
}

</style>
